export const normalizeIdrInput = (value) => {
  const digits = String(value ?? "").replace(/\D/g, "");
  return digits.replace(/^0+(?=\d)/, "");
};

export const formatIdrInput = (value) => {
  const digits = normalizeIdrInput(value);
  return digits ? digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "";
};

export const parseIdrInput = (value) => Number(normalizeIdrInput(value) || 0);
